import React, { Component } from 'react';

import { SCREEN_ID_ADMIN_GOING_TO_MARKET_V2 } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import branch from 'client/core/branch';

import SrBox from 'client/components/SrBox';
import SrPage from 'client/components/SrPage';
import SrGoingToMarketV2DataTable from 'client/components/SrGoingToMarketV2DataTable/SrGoingToMarketV2DataTable';
import SrFlexRow from 'client/components/SrFlexRow/SrFlexRow';
import SrText from 'client/components/SrText';

@withTransitionHook
@withScreenId(SCREEN_ID_ADMIN_GOING_TO_MARKET_V2)
@withScrollToTop
@branch()
@branch(() => ({
  accountManagers: ['accountManagers', 'listWithPartners'],
  appUrl: ['env', 'APP_URL'],
}))
class AdminGoingToMarketPageV2 extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Going To Market V2',
    section: 'Admin',
  });

  render() {
    return (
      <div className="AdminGoingToMarketPageV2">
        <SrPage navbarProps={{ redirectLogoTo: '/admin' }}>
          <SrBox width="90%" margin="20px auto 0px">
            <SrFlexRow>
              <SrBox>
                <SrText font="greycliff" fontSize="25px" weight="700">
                  Going To Market
                </SrText>
              </SrBox>
            </SrFlexRow>
            <SrBox marginTop="16px">
              <SrGoingToMarketV2DataTable />
            </SrBox>
          </SrBox>
        </SrPage>
      </div>
    );
  }
}

AdminGoingToMarketPageV2.displayName = 'AdminGoingToMarketPageV2';

export default AdminGoingToMarketPageV2;
